import { EditItemButton, EditItemButtonProps } from '@ui-components/actions/special/EditItemButton'
import { Fragment, ReactNode } from 'react'
import { styled } from 'styled-components'

import { Divider } from '../decorative/Divider'
import { DataSummary } from '../form/DataSummary'
import { LEGACY_SPACE_XLARGE } from '../global/legacy/spacing'
import { SecondaryHeading } from '../typography/headings/SecondaryHeading'

const HeadingWrapper = styled.div`
  margin-bottom: ${LEGACY_SPACE_XLARGE};
`

export interface SummaryViewProps {
  introSection?: ReactNode
  dataSections?: SummarySection[]
  consentSection?: ReactNode
}

export interface SummarySection {
  id: string
  title?: string
  dataSummaryTitle: string
  headingTagName?: 'h2' | 'h3'
  children: ReactNode
  isEditable: boolean
  editButtonProps?: EditItemButtonProps
}

export const SummaryView = ({ introSection, dataSections, consentSection }: SummaryViewProps) => {
  return (
    <>
      {introSection && <Section>{introSection}</Section>}
      {dataSections?.map((section, index) => (
        <Fragment key={`${section.id}-fragment`}>
          <Section id={section.id} data-testid={section.id}>
            {section?.title && (
              <HeadingWrapper>
                <SecondaryHeading header={section.title} />
              </HeadingWrapper>
            )}
            <DataSummary
              heading={section.dataSummaryTitle}
              editLink={
                section.isEditable &&
                section.editButtonProps && (
                  <EditItemButton compact={true} variant="plain" {...section.editButtonProps} />
                )
              }
              isTwoColumnLayout={true}
              headingTagName={section.title ? 'h3' : (section.headingTagName ?? 'h2')}
            >
              {section.children}
            </DataSummary>
          </Section>
          {index !== dataSections.length - 1 && <Divider />}
        </Fragment>
      ))}
      {consentSection && (
        <>
          <Divider />
          <Section>{consentSection}</Section>
        </>
      )}
    </>
  )
}

const Section = styled.section`
  > :first-child {
    margin-top: 0;
  }
`
